import { getFirebaseClientAuth } from "@/lib/firebase-client-config";

export interface Res<T> {
    isOk: boolean;
    response?: T;
    error?: any;

    statusCode: number;
}
export interface IdLabel {
    id: string | number;
    label: string;
}

const adjustHeader = async (withCredentials: boolean, header1: any, header2: any) => {
    const extra = {}
    if (withCredentials) {
        const firebaseClientAuth = await getFirebaseClientAuth();
        if (!firebaseClientAuth) {
            throw new Error('firebaseClientAuth is null');
        }
        const jwt = await firebaseClientAuth.currentUser?.getIdToken();
        if (jwt) {
            extra['Authorization'] = "Bearer " + jwt;
        }
    }
    return { ...header1, ...header2, ...extra };
}

// Wrap fetch to log message when request is sent
// const wrappedFetch = (originalFetch => {
//     return async (...args: [input: RequestInfo, init?: RequestInit | undefined]) => {
//         const result = await originalFetch.apply(this, args);
//         console.log('wrappedFetch');
//         console.log(result);
//         return result;
//     };
// })(fetch);

// Wrap fetch to log message when request is sent
const wrappedFetch = async (input: RequestInfo, init?: RequestInit) => {

    const result = await fetch(input, init);
    return result;
}

export async function createResFromResponse<T>(res: Response) {
    let body = null;
    try {
        body = await res.json();
    } catch (e) {
        console.log('Error createResFromResponse', e);
    }

    return {
        statusCode: res.status,
        isOk: res.ok,
        response: res.ok ? (body ? body as unknown as T : undefined) : undefined,
        error: !res.ok ? body : null,
    }
}
export async function createResBlobFromResponse(res: Response) {
    if (res.ok) {
        return {
            statusCode: res.status,
            isOk: res.ok,
            response: await res.blob(),
            error: null,
        }
    } else {
        let body = null;
        try {
            body = await res.json();
        } catch (e) {
            console.log('createResBlobFromResponse', e);
        }
        return {
            statusCode: res.status,
            isOk: res.ok,
            response: undefined,
            error: body,
        }
    }

}

export function createExceptionRes(exception: any) {
    return {
        statusCode: 500,
        isOk: false,
        response: undefined,
        error: exception,
    }
}

export function createUrlWithQuery(url: string, data: any = null) {
    let newUrl = url;
    // debugger
    if (data && Object.keys(data).length > 0) {
        if (url.indexOf("?") === -1) {
            newUrl += "?";
        } else {
            newUrl += "&";
        }
        Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined
                && data[key] !== 'null' && data[key] !== 'undefined'
            ) {
                if (Array.isArray(data[key])) {
                    newUrl += key + "=";
                    for (let i = 0; i < data[key].length; i++) {
                        if (i > 0) {
                            newUrl += ",";
                        }
                        newUrl += data[key][i]
                    }
                    newUrl += '&';
                } else if (typeof data[key] !== 'object') {
                    newUrl += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
                } else {
                    for (let i = 0; i < data[key].length; i++) {
                        newUrl += key + '[' + data[key][i]['id'] + ']=' + data[key][i]['option'];
                    }
                    newUrl += '&';
                }
            }
        });
    }
    return newUrl;
}

export async function commonGetData(withCredential: boolean, headers = {}, url = "", data: any = {}, cache: number | undefined = undefined) {

    const newUrl = createUrlWithQuery(url, data);

    // Default options are marked with *
    const response = await wrappedFetch(newUrl, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: await adjustHeader(withCredential, headers, {
            "Content-Type": "application/json"
        }),
        next: {
            revalidate: cache,
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response; // parses JSON response into native JavaScript objects
}


export async function commonGetFile(withCredential: boolean, headers = {}, url = "", data: any = {}) {
    const newUrl = createUrlWithQuery(url, data);

    // Default options are marked with *
    const response = await wrappedFetch(newUrl, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: await adjustHeader(withCredential, headers, {
            "Content-Type": "application/json"
        }),
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response; // parses JSON response into native JavaScript objects
}


export async function commonPostData(withCredential: boolean, headers = {}, url = "", data = {}) {
    const config: any = {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: await adjustHeader(withCredential, headers, {
            "Content-Type": "application/json"
        }),
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body data type must match "Content-Type" header
    };
    // if (Object.keys(data).length > 0) {
    config['body'] = JSON.stringify(data);
    // }

    // Default options are marked with *
    const response = await wrappedFetch(url, config);
    return response; // parses JSON response into native JavaScript objects
}

export async function commonPostDataWithForm(withCredential: boolean, headers = {}, url = "", data: any = {}) {

    const formData = new FormData();
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, data[key]);
        }
    }
    // Default options are marked with *
    const response = await wrappedFetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: await adjustHeader(withCredential, headers, {}),
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: formData, // body data type must match "Content-Type" header
    });
    return response; // parses JSON response into native JavaScript objects
}

export async function commonPutDataWithForm(withCredential: boolean, headers = {}, url = "", data: any = {}) {

    const formData = new FormData();
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, data[key]);
        }
    }
    // Default options are marked with *
    const response = await wrappedFetch(url, {
        method: "PUT", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: await adjustHeader(withCredential, headers, {}),
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: formData, // body data type must match "Content-Type" header
    });
    return response; // parses JSON response into native JavaScript objects
}

export async function commonPatchData(withCredential: boolean, headers = {}, url = "", data = {}) {
    // Default options are marked with *
    const config: any = {
        method: "PATCH", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: await adjustHeader(withCredential, headers, {
            "Content-Type": "application/json"
        }),
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data), // body data type must match "Content-Type" header
    };
    if (Object.keys(data).length > 0) {
        config['body'] = JSON.stringify(data);
    }
    const response = await wrappedFetch(url, config);
    return response; // parses JSON response into native JavaScript objects
}

export const createdLeadResToLead = (createdLeadRes: any): any => {
    // export const createdLeadResToLead = (createdLeadRes: CreatedLeadRes): Lead => {
    return {
        uuid: createdLeadRes.lead.uuid,
        status: createdLeadRes.lead.status,
        created_at: createdLeadRes.lead.created_at,
        updated_at: createdLeadRes.lead.updated_at,
        name: createdLeadRes.lead.name,
        surname: createdLeadRes.lead.surname,
        phone_country_code: createdLeadRes.lead.phone_country_code,
        phone: createdLeadRes.lead.phone,
        born_at: createdLeadRes.lead.born_at,
        italian_residence: createdLeadRes.lead.italian_residence,
        email: createdLeadRes.lead.email,
        tax_code: createdLeadRes.lead.tax_code,
        chosen_course: createdLeadRes.lead.chosen_course,
        chosen_course_price: createdLeadRes.lead.chosen_course_price,
        certifications_requirements: createdLeadRes.certifications_requirements,
        is_converted: createdLeadRes.lead.is_converted,
        is_bank_certified: createdLeadRes.lead.is_bank_certified,
        is_bank_appointment_scheduled: createdLeadRes.lead.is_bank_appointment_scheduled,
        is_bank_account_opened: createdLeadRes.lead.is_bank_account_opened,
        bank_appointment_at: createdLeadRes.lead.bank_appointment_at
    }

}